import { useEffect, useRef, type MouseEvent } from "react";
import { NAV_ITEMS } from "../../navigation/navItems";
import "./style.css";

const closeMenuOnItemClick = (
  event: MouseEvent<HTMLButtonElement>,
) => {
  const details = event.currentTarget.closest("details");
  if (details instanceof HTMLDetailsElement) {
    details.open = false;
  }
};

export const BurgerMenu = () => {
  const detailsRef = useRef<HTMLDetailsElement | null>(null);

  useEffect(() => {
    const handlePointerDown = (event: PointerEvent) => {
      const details = detailsRef.current;
      if (!details?.open) return;
      if (event.target instanceof Node && details.contains(event.target)) {
        return;
      }
      details.open = false;
    };

    document.addEventListener("pointerdown", handlePointerDown);
    return () => {
      document.removeEventListener("pointerdown", handlePointerDown);
    };
  }, []);

  return (
    <details className="burger" ref={detailsRef}>
      <summary className="burger__button" aria-label="Open menu">
        <span className="burger__icon" aria-hidden="true" />
      </summary>
      <nav className="burger__menu" aria-label="Mobile navigation">
        {NAV_ITEMS.map((item) => (
          <button
            key={item.target}
            type="button"
            className="burger__link"
            data-nav-target={item.target}
            onClick={closeMenuOnItemClick}
          >
            {item.label}
          </button>
        ))}
      </nav>
    </details>
  );
};
